import Vue from "vue";
import Router from "vue-router";
import dataManagement from "@/router/dataManagement";
import basicInformation from "@/router/basicInformation";
import iotControl from "@/router/iotControl";
import government from "@/router/government/index";
import basicMangement from "@/router/basicMangement";
import agriculturalProduct from "@/router/agriculturalProduct";
import agriculturalMange from "@/router/agriculturalMange";
import qualityRegulation from "@/router/qualityRegulation";
import earlyWarning from "@/router/earlyWarning";
import smallRoutine from "@/router/smallRoutine";
import bigData from "@/router/bigData";
import dataManage from "@/router/dataManage";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "",
            redirect: "/main",
        },
        {
            //懒加载
            path: "/main",
            // redirect: { name: 'pinia' },
            component: () => import("../layout/Main.vue"),
            children: [
                ...dataManagement,
                ...basicInformation,
                ...iotControl,
                ...government,
                ...basicMangement,
                ...agriculturalProduct,
                ...agriculturalMange,
                ...qualityRegulation,
                ...earlyWarning,
                ...smallRoutine,
                ...bigData,
                ...dataManage.reduce((res, item) => {
                    return res.concat(item);
                }, []),
                {
                    name:'authoxEmpty',
                    path:'authox-empty',
                    component:()=>import('../views/AuthoxPage.vue')
                }
            ],
        },
        {
            name: 'login',
            path: '/login',
            component: () => import('../views/Login.vue'),
        },
    ],
});
